<template>
    <div class="offer-card">
        <a :href="item.href" class="card">
            <div class="card__img">
                <img
                    :data-src="getPrismImageUrl(item.main_image, 320)"
                    :data-srcset="srcset"
                    :alt="imgAlt"
                    :src="fakeImg"
                    class="lazyload"
                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 450px, 350px"
                >
                <div class="card__img-bottombar d--flex offer-card__promo">
                    <div class="d--flex offer-card__price">
                        <span class="ts--caption color--white m-right--xxs">
                            {{ $t('offer-card.promo-price') }}
                        </span>
                        <span class="ts--body ts-weight--900 color--white">{{ item.final_price }}</span>
                    </div>
                    <span v-if="item.discount_percentage" class="badge-stamp badge-stamp--error badge-stamp--inline badge-stamp--rounded p--xs">
                        {{ item.discount_percentage }}
                    </span>
                </div>
            </div>
            <div class="card__body">
                <h6 class="ts--body-small ts-weight--900 color--grey-900 m-bottom--xxs ts--truncate">{{ item.title }}</h6>
                <p class="offer-card__description ts--body-small color--grey-700">{{ item.subtitle }}</p>
            </div>
        </a>
    </div>
</template>

<script>
import { fakeImg } from '@v4/common/utils';
import { getPrismImageUrl } from '@v4/common/utils/image';

export default {
    name: 'OfferCard',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            fakeImg,
        };
    },
    computed: {
        imgAlt() {
            return `${this.item.title}: ${this.item.subtitle}`;
        },
        srcset() {
            return `${getPrismImageUrl(this.item.main_image, 250)} 250w,
                ${getPrismImageUrl(this.item.main_image, 350)} 350w,
                ${getPrismImageUrl(this.item.main_image, 450)} 450w,
                ${getPrismImageUrl(this.item.main_image, 500)} 500w,
                ${getPrismImageUrl(this.item.main_image, 740)} 740w
            `;
        },
    },
    methods: {
        getPrismImageUrl,
    },
};
</script>
